// expo-asset-utils is used only when embedding the viewer in an expo app
module.exports = null;
